import { Injectable, InjectFlags } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { PAGE_SIZE, environment } from "../../environments/environment"
import { ApiService } from "./api.service";
import { ClinicService } from "./clinic.service";
import { SearchResult } from "../models/search-result.model";
import { CodesFileModel } from "../models/codes-file.model";
import { EmployeeDoctorModel } from "../models/doctor.model";
import { CategoryModel } from "../models/category.model";
import { GenericEstimateDetailModel, GenericEstimateModel } from "../models/generic-estimate.model";
import { ClientCodeModel } from "../models/client-code.model";
import { ZipModel } from "../models/zip.model";
import { ClientAuthorityModel } from "../models/client-authority.model";
import { ApptProcModel } from "../models/appt-proc.model";
import { SpecieModel } from "../models/specie.model";
import { ColorModel } from "../models/color.model";
import { BreedModel } from "../models/breed.model";
import { PetCodeModel } from "../models/pet-code.model";
import { BodyPartModel } from "../models/body-part.model";
import { ClinicDeptModel } from "../models/clinic-dept.model";
import { DentalCodeModel } from "../models/dental-code.model";
import { DentalProblemModel } from "../models/dental-problem.model";
import { FoodTypeModel } from "../models/food-type.model";
import { ClinicCodesModel } from "../models/clinic-codes.model";
import { ClinicModel } from "../models/clinic.model";
import { POCodesModel, POItemCodesModel } from "../models/po-codes.model";
import { VendorModel } from "../models/vendor.model";
import { BaseChargeModel } from "../models/base-charge.model";
import { ProcInfoModel } from "../models/proc-info.model";
import { ProcLinkModel } from "../models/proc-link.model";
import { ProcListModel } from "../models/proc-list.model";
import { InvtListModel } from "../models/invt-list.model";
import { DrugAdminRouteModel } from "../models/drug-admin-route.model";
import { AdminLocationModel } from "../models/admin-location.model";
import { InventInfoModel } from "../models/invent-info.model";
import { CodesByVendor } from "../models/codes-by-vendor.model";
import { QuickNoteModel } from "../models/quick-note.model";
import { NoteTypeModel } from "../models/note-type.model";
import { DepartmentsModel } from "../models/departments.model";
import { DiagnosisModel } from "../models/diagnosis.model";
import { PromptModel } from "../models/prompt.model";
import { IndicationModel } from "../models/indication-model";
import { PetNoteTypeModel } from "../models/pet-note.model";
import { WhiteGoodsDetailModel } from "../models/white-goods-detail.model";
import { TypesModel } from "../models/types.model"; 
import { UserRolesModel } from "../models/user-roles.model"; 
import { TitleModel } from "../models/title.model"; 
import { ClinicSublocationModel } from "../models/clinic-sublocation.model";
import { ClinicLocationModel } from "../models/clinic-location.model";

@Injectable({
    providedIn: "root"
})
export class CatalogService {

    private baseUrl: string = 'catalog';
    codes_file: CodesFileModel[] = [];
    codes_aliases: CodesFileModel[] = [];
    employee_doctors: EmployeeDoctorModel[] = [];
    employee_all: EmployeeDoctorModel[] = [];
    categories: CategoryModel[] = [];
    subcategories: CategoryModel[] = [];
    generic_estimates: GenericEstimateModel[] = [];
    generic_estimates_detail: GenericEstimateDetailModel[] = [];
    client_code: ClientCodeModel[] = []
    zip: ZipModel[] = []
    zip_v: ZipModel = new ZipModel('', '', '', '', 0)
    client_authority: ClientAuthorityModel[] = []
    appt_proc: ApptProcModel[] = []
    specie: SpecieModel[] = []
    color: ColorModel[] = []
    breed: BreedModel[] = []
    pet_code: PetCodeModel[] = []
    body_part: BodyPartModel[] = []
    clinic_dept: ClinicDeptModel[] = []
    dental_code: DentalCodeModel[] = []
    dental_problem: DentalProblemModel[] = []
    food_type: FoodTypeModel[] = []
    clinic_code: ClinicCodesModel[] = []
    clinic: ClinicModel[] = []
    po_codes: POCodesModel[] = []
    po_item_codes: POItemCodesModel[] = []
    vendors: VendorModel[] = []
    get activeVendors(): VendorModel[] {
        return this.vendors.filter(v => v.vendor_active)
    }
    base_charge: BaseChargeModel[] = []
    proc_links: ProcLinkModel[] = []
    procedure_list: ProcListModel[] = []
    inventory_list: InvtListModel[] = []
    drug_admin_route: DrugAdminRouteModel[] = []
    admin_location: AdminLocationModel[] = []
    codes_vendor: CodesByVendor[] = []
    quick_notes: QuickNoteModel[] = []
    note_type: NoteTypeModel[] = []
    departments: DepartmentsModel[] = []
    diagnosis: DiagnosisModel[] = []
    proc_info: ProcInfoModel = new ProcInfoModel('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '','');
    prompt: PromptModel[] = [] 
    indication_list: IndicationModel[] = [] 
    pet_note_type: PetNoteTypeModel[] = []
    suture_codes: WhiteGoodsDetailModel[] = []; 
    types: TypesModel[] = [];
    addressess : ZipModel[] = []
    user_roles: UserRolesModel[] = [];
    titles: TitleModel[] = [];
    clinic_location: ClinicLocationModel[] = [];
    clinic_sublocation: ClinicSublocationModel[] = [];
    brief_history_category: string[] = [];
 
    constructor(
        private api: ApiService,
        private clinicService: ClinicService
    ) {

    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }

    oneLoadCatalogs(clinic_no: number) {
        this.getCodesFile_Aliases(true, clinic_no).then(() => { });
        this.getCodesFile(true, clinic_no).then(() => { });
        this.getDoctors().then(() => { });
        this.getCategories().then(() => { });
        this.getGenericEstimates().then(() => { });
        this.getClientCode().then(() => { });
        this.getZip().then(() => { });
        this.getClientAuthority().then(() => { });
        this.getApptProc().then(() => { });
        this.getSpecie().then(() => { });
        this.getColor().then(() => { });
        this.getBreed().then(() => { });
        this.getPetCode().then(() => { });
        this.getBodyPart().then(() => { });
        this.getClinicDept().then(() => { });
        this.getClinicLocation().then(() => { });
        this.getDentalCode().then(() => { });
        this.getDentalProblem().then(() => { });
        this.getFoodType().then(() => { });
        this.getClinicCodes().then(() => { });
        this.getEmployees().then(() => { }); 
        this.getVendors().then(() => { });
        this.getBaseCharge().then(() => { });
        this.getProcedureList().then(() => { });
        this.getInventoryList().then(() => { });
        this.getDrugAdminRoute().then(() => { });
        this.getCodesByVendor().then(() => { });
        this.getQuickNote().then(() => { });
        this.getNoteType().then(() => { });
        this.getDepartments().then(() => { });
        this.getDiagnosis().then(() => { });
        this.getPrompt().then(() => { });
        this.getPetNoteTypeList().then(() => { }); 
        this.getSutureCodes(clinic_no).then(() => { });
        this.getClinicLocation().then(() => { });
    }

    getCodesFile(refill: boolean = false, clinic_no: number,include_all: number = 0) {
        let promise = new Promise((resolve, reject) => {
            if (refill) {
                localStorage.removeItem('codes_file');
                this.codes_file = [];
            } else {
                // Only use localStorage if refill is false
                if (localStorage.codes_file) {
                    this.codes_file = JSON.parse(localStorage['codes_file']);
                    resolve(1);
                    return;
                }
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${1}&sequence=${clinic_no}&sequence2=${include_all}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.codes_file = res.data.map((element) => {
                            const item = new CodesFileModel(element.procedure_no, element.procedure_clinic, element.code_no, element.code_type, element.code_name, element.code_active, element.code_specie, element.code_approval, element.code_fix, element.code_modified_date, element.code_category, element.code_sub_category, element.brief_history_category, element.code_clinic, element.procedure_desc, element.type);
                            item.CodeFileID = element.CodeFileID ?? element.code_no;
                            return item;
                        });
                        // The cache is optional: a full localStorage must not break the load.
                        try { localStorage['codes_file'] = JSON.stringify(this.codes_file); } catch { localStorage.removeItem('codes_file'); }
                        resolve(1);
                    } else {
                        this.codes_file = [];
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    getCodesFile_Aliases(refill: boolean = false, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            if (refill) {
                localStorage.removeItem('codes_aliases');
                this.codes_aliases = [];
            } else {
                // Only use localStorage if refill is false
                if (localStorage.codes_aliases) {
                    this.codes_aliases = JSON.parse(localStorage['codes_aliases']);
                    resolve(1);
                    return;
                }
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${57}&sequence=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.codes_aliases = res.data.map((element) => {
                            const item = new CodesFileModel(element.procedure_no, element.procedure_clinic, element.code_no, element.code_type, element.code_name, element.code_active, element.code_specie, element.code_approval, element.code_fix, element.code_modified_date, element.code_category, element.code_sub_category, element.brief_history_category, element.code_clinic, element.procedure_desc, element.type);
                            return item;
                        });
                        try { localStorage['codes_aliases'] = JSON.stringify(this.codes_aliases); } catch { localStorage.removeItem('codes_aliases'); }
                        resolve(1);
                    } else {
                        this.codes_aliases = [];
                        resolve(0);
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    getDoctors() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.employee_doctors) {
                this.employee_doctors = JSON.parse(localStorage['employee_doctors']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${2}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.employee_doctors = res.data.map((element) => {
                            return new EmployeeDoctorModel(element.employee_no, element.employee_initial, element.employee_name);
                        });
                        localStorage['employee_doctors'] = JSON.stringify(this.employee_doctors)
                        resolve(1);
                    } else {
                        this.employee_doctors = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getCategories() { 
        let promise = new Promise((resolve, reject) => {
            if (localStorage.categories) {
                this.categories = JSON.parse(localStorage['categories']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${3}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.categories = res.data.map((element) => {
                            return new CategoryModel(element.category_no, element.category_name, element.category_code, 0);
                        });
                        localStorage['categories'] = JSON.stringify(this.categories)
                        resolve(1);
                    } else {
                        this.categories = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getGenericEstimates() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.generic_estimates) {
                this.generic_estimates = JSON.parse(localStorage['generic_estimates']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${4}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.generic_estimates = res.data.map((element) => {
                            return new GenericEstimateModel(element.estimate_sequence, element.estimate_name, element.date_added, element.total_charge);
                        });
                        localStorage['generic_estimates'] = JSON.stringify(this.generic_estimates)
                        resolve(1);
                    } else {
                        this.generic_estimates = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getGenericEstimatesDetail(sequence: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${5}&sequence=${sequence}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.generic_estimates_detail = []
                        this.generic_estimates_detail = res.data.map((element) => {
                            return new GenericEstimateDetailModel(element.dept_estimate_sequence, element.estimate_def_sequence, element.link_no, element.link_type, element.link_count, element.link_cost, element.code_name, element.code_category, element.code_no, element.defined);
                        });
                        resolve(1);
                    } else {
                        this.generic_estimates_detail = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClientCode() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.client_code) {
                this.client_code = JSON.parse(localStorage['client_code']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${6}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.client_code = res.data.map((element) => {
                            return new ClientCodeModel(element.code, element.name);
                        });
                        localStorage['client_code'] = JSON.stringify(this.client_code)
                        resolve(1);
                    } else {
                        this.client_code = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getZip() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.zip) {
                this.zip = JSON.parse(localStorage['zip']);
                this.addressess = JSON.parse(localStorage['zip']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${7}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.zip = res.data.map((element) => {
                            return new ZipModel(element.zip_code, element.city, element.county, element.state, element.rab_year);
                        }); 

                        this.addressess = res.data.map((element) => {
                            return new ZipModel(element.zip_code, element.city, element.county, element.state, element.rab_year);
                        });
                        localStorage['zip'] = JSON.stringify(this.zip)
                        resolve(1);
                    } else {
                        this.zip = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClientAuthority() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.client_authority) {
                this.client_authority = JSON.parse(localStorage['client_authority']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${8}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.client_authority = res.data.map((element) => {
                            return new ClientAuthorityModel(element.authority_id, element.authority_desc);
                        });
                        localStorage['client_authority'] = JSON.stringify(this.client_authority)
                        resolve(1);
                    } else {
                        this.client_authority = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getApptProc() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.appt_proc) {
                this.appt_proc = JSON.parse(localStorage['appt_proc']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${10}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.appt_proc = res.data.map((element) => {
                            return new ApptProcModel(element.appt_proc_id, element.appt_proc_code, element.appt_doctor_slots);
                        });
                        localStorage['appt_proc'] = JSON.stringify(this.appt_proc)
                        resolve(1);
                    } else {
                        this.appt_proc = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getSpecie() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.specie) {
                this.specie = JSON.parse(localStorage['specie']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${11}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.specie = res.data.map((element) => {
                            return new SpecieModel(element.specie_index, element.specie_name);
                        });
                        localStorage['specie'] = JSON.stringify(this.specie)
                        resolve(1);
                    } else {
                        this.specie = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getColor() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.color) {
                this.color = JSON.parse(localStorage['color']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${12}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.color = res.data.map((element) => {
                            return new ColorModel(element.color_index, element.color_name);
                        });
                        localStorage['color'] = JSON.stringify(this.color)
                        resolve(1);
                    } else {
                        this.color = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getBreed() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.breed) {
                this.breed = JSON.parse(localStorage['breed']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${13}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.breed = res.data.map((element) => {
                            return new BreedModel(element.breed_index, element.breed_name);
                        });
                        localStorage['breed'] = JSON.stringify(this.breed)
                        resolve(1);
                    } else {
                        this.breed = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    
    getPetCode() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.pet_code) {
                this.pet_code = JSON.parse(localStorage['pet_code']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${14}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_code = res.data.map((element) => {
                            return new PetCodeModel(element.code, element.name);
                        });
                        localStorage['pet_code'] = JSON.stringify(this.pet_code)
                        resolve(1);
                    } else {
                        this.pet_code = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getBodyPart() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.body_part) {
                this.body_part = JSON.parse(localStorage['body_part']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${15}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.body_part = res.data.map((element) => {
                            return new BodyPartModel(element.bodypartno, element.body_part);
                        });
                        localStorage['body_part'] = JSON.stringify(this.body_part)
                        resolve(1);
                    } else {
                        this.body_part = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClinicDept() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.clinic_dept) {
                this.clinic_dept = JSON.parse(localStorage['clinic_dept']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${16}&sequence=${this.userData.clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) { 
                        this.clinic_dept = res.data.map((element) => {
                            return new ClinicDeptModel(element.clinic_dept, element.clinic_desc, (element.clinic_dept_code).replace(/\s/g, ""), element.clinic_no);
                        });
                        localStorage['clinic_dept'] = JSON.stringify(this.clinic_dept)
                        resolve(1);
                    } else {
                        this.clinic_dept = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getDentalProblem() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.dental_problem) {
                this.dental_problem = JSON.parse(localStorage['dental_problem']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${17}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.dental_problem = res.data.map((element) => {
                            return new DentalProblemModel(element.problem_index, element.problem_name);
                        });
                        localStorage['dental_problem'] = JSON.stringify(this.dental_problem)
                        resolve(1);
                    } else {
                        this.dental_problem = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getDentalCode() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.dental_code) {
                this.dental_code = JSON.parse(localStorage['dental_code']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${18}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.dental_code = res.data.map((element) => {
                            return new DentalCodeModel(element.code_no, element.code_name);
                        });
                        localStorage['dental_code'] = JSON.stringify(this.dental_code)
                        resolve(1);
                    } else {
                        this.dental_code = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getFoodType() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.food_type) {
                this.food_type = JSON.parse(localStorage['food_type']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${19}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.food_type = res.data.map((element) => {
                            return new FoodTypeModel(element.item_no, element.item_desc);
                        });
                        localStorage['food_type'] = JSON.stringify(this.food_type)
                        resolve(1);
                    } else {
                        this.food_type = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClinicCodes() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.clinic_code) {
                this.clinic_code = JSON.parse(localStorage['clinic_code']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${20}&sequence=1`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.clinic_code = res.data.map((element) => {
                            return new ClinicCodesModel(element.pet_info_proc_no, element.pet_info_proc_type);
                        });
                        localStorage['clinic_code'] = JSON.stringify(this.clinic_code)
                        resolve(1);
                    } else {
                        this.clinic_code = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getEmployees() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.employee_all) {
                this.employee_all = JSON.parse(localStorage['employee_all']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${21}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.employee_all = res.data.map((element) => {
                            return new EmployeeDoctorModel(element.employee_no, element.employee_initial, element.employee_name);
                        });
                        localStorage['employee_all'] = JSON.stringify(this.employee_all)
                        resolve(1);
                    } else {
                        this.employee_all = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getSubCategories(sequence: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${22}&sequence=${sequence}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.subcategories = [];
                        this.subcategories = res.data.map((element) => {
                            return new CategoryModel(element.category_no, element.category_name, element.category_code, 0);
                        });
                        resolve(1);
                    } else {
                        this.subcategories = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClinics() {
        let promise = new Promise((resolve, reject) => {
            // if (localStorage.clinic) {
            //     this.clinic = JSON.parse(localStorage['clinic']);
            //     resolve(1);
            //     return;
            // }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${23}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.clinic = [];
                        this.clinic = res.data.map((element) => {
                            return new ClinicModel(element.clinic_no, element.clinic_abbrev, element.clinic_name, element.clinic_type, element.clinic_store_no, element.clinic_code, element.clinic_address, element.clinic_zip, element.clinic_zip_ext, element.clinic_phone, element.clinic_fax, element.clinic_email, element.tax_rate1, element.tax_rate2, element.tax_rate3, element.invoice_message, element.rab_proc, element.health_proc, element.neu_proc, element.pet_info_proc, element.city_lic_no, element.rabie_lic_city, element.lab_result_flag, element.ask_tax, element.clinic_doctor, element.doctor_date, element.admin_password, element.corp_password, element.manage_password, element.inv_proc_password, element.clinic_active, element.tenant_no, element.web_phone, element.country_code);
                        });
                        localStorage['clinic'] = JSON.stringify(this.clinic)
                        resolve(1);
                    } else {
                        this.clinic = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getPOCodes(sequence: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${24}&sequence=${sequence}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.po_codes = [];
                        this.po_codes = res.data.map((element) => {
                            return new POCodesModel(element.item_code, element.item_desc, element.code_type, element.code_no, element.vendor, element.vendor_code, element.manufacturer_code);
                        });
                        resolve(1);
                    } else {
                        this.po_codes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getVendors() {
        let promise = new Promise((resolve, reject) => {
            // if (localStorage.vendors) {
            //     this.vendors = JSON.parse(localStorage['vendors']);
            //     resolve(1);
            //     return;
            // }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${25}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.vendors = [];
                        this.vendors = res.data.map((element) => {
                            return new VendorModel(element.vendor_code, element.vendor_name, element.contact, element.order_phone_no, element.cust_service_no, element.fax_no, element.email_address, element.street_address, element.vendor_zip, element.vendor_zip_ext, element.vendor_active, element.delivery_time, element.vendor_acct_no, element.vendor_message);
                        });
                        localStorage['vendors'] = JSON.stringify(this.vendors)
                        resolve(1);
                    } else {
                        this.vendors = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getBaseCharge() {
        let promise = new Promise((resolve, reject) => {
            // if (localStorage.base_charge) {
            //     this.base_charge = JSON.parse(localStorage['base_charge']);
            //     resolve(1);
            //     return;
            // }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${26}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.base_charge = [];
                        this.base_charge = res.data.map((element) => {
                            return new BaseChargeModel(element.base_charge_code, element.base_charge_price, element.base_charge_desc);
                        });
                        localStorage['base_charge'] = JSON.stringify(this.base_charge)
                        resolve(1);
                    } else {
                        this.base_charge = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getProcInfo(sequence: number, sequence2: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${27}&sequence=${sequence}&sequence2=${sequence2}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.proc_info = new ProcInfoModel(res.data[0].code_active, res.data[0].code_category, res.data[0].code_sub_category, res.data[0].brief_history_category, res.data[0].code_fix, res.data[0].procedure_basechg, res.data[0].procedure_tax1, res.data[0].procedure_tax2, res.data[0].procedure_tax3, res.data[0].procedure_response, res.data[0].procedure_sex, res.data[0].code_specie, res.data[0].code_approval, res.data[0].procedure_price, res.data[0].procedure_min_price, res.data[0].procedure_class, res.data[0].procedure_comm1, res.data[0].procedure_comm2, res.data[0].procedure_comm3, res.data[0].code_modified_date, res.data[0].link_modified_date, res.data[0].procedure_print,res.data[0].procedure_rescueprice);
                        resolve(1);
                    } else {
                        this.proc_info = new ProcInfoModel('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '','');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getProcLinks(proc_no: number, code_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${28}&sequence=${proc_no}&sequence2=${code_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.proc_links = [];
                        this.proc_links = res.data.map((element) => {
                            return new ProcLinkModel(element.code_name, element.link_no, element.link_type, element.link_sequence, element.link_category, element.link_active, element.link_weight1, element.link_weight2, element.link_age1, element.link_age2, element.link_specie, element.link_sex, element.link_rec_fix, element.link_dosage, element.link_chk_price, element.link_reg_price, element.link_price, element.link_basechg, element.link_add_price, element.link_variance, element.link_frequency, element.link_sub_hist, element.link_printable, element.link_sale_treat, element.link_clinic, element.link_breed,element.link_rescueprice,element.link_altdays,element.link_mindose,element.link_maxdose,element.link_indicationID,element.link_notes,element.link_days,element.link_id,element.indications,element.link_dosageunit,element.specie_name,element.breed_name,element.proc_no);
                        });
                        resolve(1);
                    } else {
                        this.proc_links = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getProcLinkInfo(link_no: number, code_clinic: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>
            (`${this.baseUrl}/?type=${54}&sequence=${link_no}&sequence2=${code_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.proc_links = [];
                        this.proc_links = res.data.map((element) => {
                            return new ProcLinkModel(element.code_name, element.link_no, element.link_type, element.link_sequence, element.link_category, element.link_active, element.link_weight1, element.link_weight2, element.link_age1, element.link_age2, element.link_specie, element.link_sex, element.link_rec_fix, element.link_dosage, element.link_chk_price, element.link_reg_price, element.link_price, element.link_basechg, element.link_add_price, element.link_variance, element.link_frequency, element.link_sub_hist, element.link_printable, element.link_sale_treat, element.link_clinic, element.link_breed,element.link_rescueprice,element.link_altdays,element.link_mindose,element.link_maxdose,element.link_indicationID,element.link_notes,element.link_days,element.link_id,element.indications,element.link_dosageunit,element.specie_name,element.breed_name,element.proc_no);
                        });
                        resolve(1);
                    } else {
                        this.proc_links = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getIndications() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${50}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.indication_list = [];
                        this.indication_list = res.data.map((element) => {
                            return new IndicationModel(element.indicationID, element.indications);
                        });
                        resolve(1);
                    } else {
                        this.indication_list = [];
                        resolve(0);
                    }
                });
        });
        
        return promise;
    }

    getDrugAdminRoute() {
        let promise = new Promise((resolve, reject) => {
          /*  if (localStorage.drug_admin_route) {
                this.drug_admin_route = JSON.parse(localStorage['drug_admin_route']);
                resolve(1);
                return;
            }
*/
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${29}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.drug_admin_route = [];
                        this.drug_admin_route = res.data.map((element) => {
                            return new DrugAdminRouteModel(element.route_abbrev, element.route_note);
                        });
                        localStorage['drug_admin_route'] = JSON.stringify(this.drug_admin_route)
                        resolve(1);
                    } else {
                        this.drug_admin_route = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getAdminLocation() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${58}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.admin_location = [];
                        this.admin_location = res.data.map((element) => {
                            return new AdminLocationModel(element.admin_location_code, element.admin_location_desc);
                        });
                        resolve(1);
                    } else {
                        this.admin_location = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getCodesByVendor() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${30}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.codes_vendor = [];
                        this.codes_vendor = res.data.map((element) => {
                            return new CodesByVendor(element.vendor, element.code, element.codes);
                        });
                        resolve(1);
                    } else {
                        this.proc_links = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getQuickNote() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${31}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.quick_notes = [];
                        this.quick_notes = res.data.map((element) => {
                            return new QuickNoteModel(element.quick_note_code, element.quick_note_type, element.quick_note_text);
                        });
                        resolve(1);
                    } else {
                        this.proc_links = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getNoteType() {
        let promise = new Promise((resolve, reject) => {
            if (localStorage.note_type) {
                this.note_type = JSON.parse(localStorage['note_type']);
                resolve(1);
                return;
            }

            this.api.get<SearchResult>(`${this.baseUrl}/?type=${32}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.note_type = [];
                        this.note_type = res.data;
                        resolve(1);
                    } else {
                        this.proc_links = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getProcedureList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`client/GetProcedureList`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.procedure_list = res.data.map((element) => {
                            return new ProcListModel(element.procedure_no, element.procedure_code, element.procedure_desc, element.procedure_price, element.procedure_clinic);
                        });
                        resolve(1);
                    } else {
                        this.procedure_list = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getInventoryList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`client/GetInventoryList`)
            .subscribe((res: any) => {
                if (res && res.results > 0) {
                    this.inventory_list = res.data.map((element) => {
                        return new InvtListModel(element.unit_price, element.item_no, element.item_clinic, element.item_presc_code);
                    });
                    resolve(1);
                } else {
                    this.inventory_list = [];
                    resolve(0);
                }
            });
        });
        return promise;
    } 

    getPOItemCodes(sequence: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${33}&sequence=${sequence}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.po_item_codes = [];
                        this.po_item_codes = res.data.map((element) => {
                            return new POItemCodesModel(element.code_name, element.code_no, element.code_type, element.order_code, element.order_no, element.container_cost, element.qty, element.vendor_code);
                        });
                        resolve(1);
                    } else {
                        this.po_item_codes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getDepartments() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${34}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.departments = res.data.map((element) => {
                            return new DepartmentsModel(element.dept_id, element.dept_desc, element.dept_note);
                        });
                        resolve(1);
                    } else {
                        this.departments = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getDiagnosis() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${35}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.diagnosis = res.data.map((element) => { 
                            return new DiagnosisModel(element.ConceptID, element.PreferredTerm, element.OtherTerm, element.EffectiveTime, element.ModuleID, element.DescriptionID);
                        }); 
                        resolve(1);
                    } else {
                        this.diagnosis = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getPrompt() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${36}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.prompt = res.data.map((element) => {
                            return new PromptModel(element.id, element.title, element.prompt);
                        });
                        resolve(1);
                    } else {
                        this.prompt = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getSutureCodes(sequence) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${37}&sequence=${sequence}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.suture_codes = res.data.map((element) => {
                            return new WhiteGoodsDetailModel(element.item_no, element.item_code, element.item_desc, element.item_category, element.code_active, element.order_no, element.reorder_qty,
                                element.qty_ytd, element.qty_this_month, element.qty_month_1, element.qty_month_2,
                                element.qty_month_3, element.qty_month_4, element.qty_month_5, element.qty_month_6,
                                element.qty_month_7, element.qty_month_8, element.qty_month_9, element.qty_month_10,
                                element.qty_month_11, element.qty_month_12, element.item_unit, element.item_modified_date);
                        });
                        resolve(1);
                    } else {
                        this.suture_codes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getPetNoteTypeList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${38}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_note_type = res.data.map((element) => {
                            return new PetNoteTypeModel(element.note_type, element.type_desc);
                        });
                        resolve(1);
                    } else {
                        this.pet_note_type = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getTypes(categoryid: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${51}&sequence=${categoryid}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.types = res.data.map((element) => {
                            return new TypesModel(element.typeid, element.typecode, element.typedescription,element.categoryid);
                        });
                        resolve(1);
                    } else {
                        this.types = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }
 
    address: {zip: string, city: string, county: string, state: string} = {zip: '', city: '', county: '', state: ''};
    getAddresses(value,from){
        console.log(value,from)
        let addressess = JSON.parse(localStorage['zip']);  

        this.address.zip = addressess.find(x => x.zip_code == value).zip_code;
        this.address.city = addressess.find(x => x.zip_code == value).city;
        this.address.county = addressess.find(x => x.zip_code == value).county;
        this.address.state = addressess.find(x => x.zip_code == value).state;
    }

    getAddressDropdowns(value,type) {  
        // if(type == 'zip' && value != '') {
        //     console.log('mm')
        //     this.a_zip = this.addressess.filter((word) => word.zip_code.includes(value)); 
        //     this.a_city = this.addressess.filter((word) => word.zip_code.includes(value));
        //     this.a_county = this.addressess.filter((word) => word.zip_code.includes(value));
        //     this.addressess = this.addressess.filter((word) => word.zip_code.includes(value));
        // }
        // else{
        //     console.log('nn')
        //     this.a_zip = this.addressess.map(address => address.zip_code);
        //     this.a_city = this.addressess.map(address => address.city);
        //     this.a_county = this.addressess.map(address => address.county);
        //     this.a_state = this.addressess.map(address => address.state);
        //     console.log(this.addressess)
        // } 
    }

    filterArray<T>(array: T[], item: string, property: string) {
        return array
            .filter((word: T) => this.compareTwoStrings(word[property].normalize("NFD").replace(/[\u0300\u0301]/g, ""), item))
            .sort((a: T, b: T) => {
                if (a[property].toLowerCase() < b[property].toLowerCase()) {
                    return -1;
                }
                if (a[property].toLowerCase() > b[property].toLowerCase()) {
                    return 1;
                }
                return 0;
            });
    }

    compareTwoStrings(string: any, subString: any) {
        if (string.toLowerCase().normalize("NFD").replace(/[\u0300\u0301]/g, "").includes(subString)) return subString;
    }

    paginate(array, page_number) {
        // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
        return array.slice((page_number - 1) * PAGE_SIZE, page_number * PAGE_SIZE);
    }

    getUserRoles() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${52}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.user_roles = res.data.map((element) => {
                            return new UserRolesModel(element.id, element.name, element.normalizedname,element.selected);
                        });
                        resolve(1);
                    } else {
                        this.user_roles = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getTitles() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${53}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.titles = res.data.map((element) => {
                            return new TitleModel(element.title_id, element.title, element.title_description);
                        });
                        resolve(1);
                    } else {
                        this.titles = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    getClinicLocation() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/?type=${56}&sequence=${this.userData.clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.clinic_location = res.data.map((element: any) => {
                            return new ClinicLocationModel(element.location_id, element.location_code, element.location_desc, element.remarks, element.clinic_no);
                        });
                        resolve(1);
                    } else {
                        this.clinic_location = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }
    
    getClinicSubLocation() { 
        let promise = new Promise((resolve, reject) => { 
            this.api.get<SearchResult>(`clinic/GetClinicSubLocationByLoc?clinic_dept_code=${0}&clinic_no=${this.clinicService.current_clinic}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) {
                        this.clinic_sublocation = res.data.map((element) => {
                            return new ClinicSublocationModel(element.sublocation_id, element.sublocation_code, element.sublocation_desc, element.specie, element.category, element.occupied, element.type, element.size, element.note, element.clinic_no, element.location_id);
                        }); 
                        resolve(1);
                    } else {
                        this.clinic_sublocation = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getBriefHistoryCategory() {
        const path = `${this.baseUrl}/?type=${55}`;
        return new Promise((resolve, reject) => {
            this.api.get<SearchResult>(path).subscribe(
                (res: any) => {
                    if (res && res.data) {
                        this.brief_history_category = res.data.map((element) => {
                            return element.brief_history_category;
                        });
                        resolve(1);
                    } else {
                        this.brief_history_category = [];
                        resolve(0);
                    }
                },
                (err) => {
                    this.brief_history_category = [];
                    reject(err);
                }
            );
        });
    }


    

}